import React, { useEffect, useRef } from "react";
import ReactDom from "react-dom";
import { motion } from "framer-motion";
import { closeIcon } from "../../Base/SVG";

export default function TreatCard({ closeFunc, setModal, modalData }) {
  const modalRef = useRef(null);

  // Focus trap and escape key handling
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setModal(null);
      }
    };

    // Focus the modal when it opens
    if (modalRef.current) {
      modalRef.current.focus();
    }

    // Add event listener for escape key
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setModal]);

  return ReactDom.createPortal(
    <motion.div
      className="treat__modals"
      onClick={closeFunc}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      exit={{ opacity: 0 }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        className="treatCard"
        ref={modalRef}
        tabIndex="-1"
      >
        <div
          className="treatCard__close"
          onClick={() => setModal(null)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setModal(null);
              e.preventDefault();
            }
          }}
          role="button"
          aria-label="Close modal"
          tabIndex="0"
        >
          <span aria-hidden="true">{closeIcon}</span>
        </div>
        <div className="treatCard__title">
          <h4 id="modal-title">{modalData.title}</h4>
          <span aria-hidden="true"></span>
        </div>
        <div className="treatCard__body">
          <p>{modalData.text}</p>
        </div>
      </div>
    </motion.div>,
    document.getElementById("popups")
  );
}
